import React from 'react';

const Icon = ({ size = '21', fill = 'url(#prefix_dxc-svg-to-react_b)', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 21 21" fill="none" {...other}>
            <g filter="url(#a)">
                <path
                    d="m15.502 4.189 1.52 1.52-4.896 4.897L17 15.48 15.48 17l-4.874-4.874-4.897 4.897-1.52-1.52 4.896-4.897-4.874-4.874 1.52-1.52 4.875 4.873 4.896-4.896Z"
                    fill="url(#b)"
                />
            </g>
            <defs>
                <linearGradient id="b" x1="30.225" y1="-22.384" x2="52.108" y2="6.644" gradientUnits="userSpaceOnUse">
                    <stop offset="0.226" stopColor="#FFF6E0" />

                    <stop offset="0.663" stopColor="#8E6B40" />
                </linearGradient>
                <filter id="a" x="3.888" y="4.188" width="13.134" height="13.134" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />

                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />

                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />

                    <feOffset dx="-0.3" dy="0.3" />

                    <feGaussianBlur stdDeviation="0.9" />

                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />

                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.59 0" />

                    <feBlend in2="shape" result="effect1_innerShadow_6471_18210" />
                </filter>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
